export const overrides = {
	overrides: {
		MuiButton: {
			text: {
				size: 16,
			},
		},
	},
};
